import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  PredictiveSearch,
  RecentListItem
} from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import {
  ButtonDirective,
  CheckboxDirective,
  LinkDirective,
  Option,
  SelectComponent,
  SelectedData,
  Tab
} from '@com-delta-omnichannel/mach';
import { SelectedRange } from '@com-delta-omnichannel/mach/lib/components/organisms/date-picker/models/date-picker.interfaces';
import {
  BookWidgetFieldInfoTypes,
  BookWidgetFieldUpdateTypes,
  TripTypeOptions
} from '../../../../constants/book-widget.constants';
import { BookWidgetAem } from '../../../../models/book-widget-aem.interfaces';
import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { BookWidgetFields } from '../../../../models/book-widget-fields.interfaces';
import { DatepickerConfig } from '../../../../models/common.interfaces';
import {
  SearchModalEvent,
  SearchModalEventType
} from '../../../../models/search-modal-events-object.interface';
import { OneWayRoutePickerComponent } from '../../../common';
import { BestFareOptionsComponent } from '../../../common/best-fare-options/best-fare-options.component';
import { FlightDatePickerComponent } from '../../../common/flight-date-picker/flight-date-picker.component';
import { MeetingEventCodeComponent } from '../../../common/meeting-event-code/meeting-event-code.component';

@Component({
  selector: 'idp-apps-book-widget-desktop-ow-rt',
  standalone: true,
  imports: [
    CommonModule,
    SelectComponent,
    CheckboxDirective,
    LinkDirective,
    ButtonDirective,
    OneWayRoutePickerComponent,
    BestFareOptionsComponent,
    MeetingEventCodeComponent,
    FlightDatePickerComponent
  ],
  templateUrl: './apps-book-widget-desktop-ow-rt.component.html',
  styleUrls: ['./apps-book-widget-desktop-ow-rt.component.scss']
})
export class BookWidgetOwRtDesktopComponent {
  protected tripTypeOptions = TripTypeOptions;
  protected bookWidgetFieldInfoTypes = BookWidgetFieldInfoTypes;
  protected bookWidgetFieldUpdateTypes = BookWidgetFieldUpdateTypes;

  @Input() bookWidgetFields!: BookWidgetFields;
  @Input() bookWidgetAem: BookWidgetAem = {} as BookWidgetAem;
  @Input() recentSearchList: RecentListItem[] = [];
  @Input() savedSearchList: string[] = [];
  @Input() searchModalTabs: Tab[] = [];
  @Input() predictiveSearchData!: PredictiveSearch;
  @Input() isFullscreen!: boolean;
  @Input() datepickerConfig: DatepickerConfig = {} as DatepickerConfig;
  @Output() infoIconClick: EventEmitter<BookWidgetFieldInfoTypes> =
    new EventEmitter<BookWidgetFieldInfoTypes>();

  @Output() bookWidgetFieldChange =
    new EventEmitter<BookWidgetFieldUpdateEvent>();

  @Output() swapClicked = new EventEmitter<number>();
  @Output() findFlight = new EventEmitter();
  @Output() searchModalTriggerClicked = new EventEmitter<SelectedData>();

  @Output() searchModalEvent = new EventEmitter<
    SearchModalEvent<SearchModalEventType>
  >();

  onDropdownSelectionChange(
    event: Option,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: event.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onDateSelectionChange(
    event: SelectedRange,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes,
    index: number
  ) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        selectedRange: event,
        flightIndex: index
      },
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onCheckBoxChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.checked,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  onInputFieldChange(
    event: Event,
    bookWidgetFieldUpdateType: BookWidgetFieldUpdateTypes
  ) {
    const target = event.target as HTMLInputElement;
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: target.value,
      type: bookWidgetFieldUpdateType
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }

  findFlightSubmit() {
    this.findFlight.emit();
  }

  infoIconClickHandler(sourceIcon: BookWidgetFieldInfoTypes) {
    if (sourceIcon) this.infoIconClick.emit(sourceIcon);
  }
}
